// This is a replacement for the standard headers because we want to be able to add line breaks within our display names
export default `<div
  role="columnheader"
  ng-class="{ 'sortable': sortable }"
  ui-grid-one-bind-aria-labelledby-grid="col.uid + '-header-text ' + col.uid + '-sortdir-text'"
  aria-sort="{{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending' : (!col.sort.direction ? 'none' : 'other'))}}">
  <div
    role="button"
    tabindex="0"
    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"
    col-index="renderIndex"
    title="TOOLTIP">
    <span
      class="ui-grid-header-cell-label"
      ui-grid-one-bind-id-grid="col.uid + '-header-text'"
      ng-bind-html="col.displayName CUSTOM_FILTERS"
      data-test-selector="{{'Column Header ' + col.colDef.name}}">
    </span>

    <span
      ui-grid-one-bind-id-grid="col.uid + '-sortdir-text'"
      ui-grid-visible="col.sort.direction"
      aria-label="{{getSortDirectionAriaLabel()}}">
      <i
       ng-class="{ 'ui-grid-icon-up-dir': col.sort.direction == asc, 'ui-grid-icon-down-dir': col.sort.direction == desc, 'ui-grid-icon-blank': !col.sort.direction }"
       title="{{isSortPriorityVisible() ? i18n.headerCell.priority + ' ' + ( col.sort.priority + 1 )  : null}}"
       aria-hidden="true">
     </i>
     <sub
       ui-grid-visible="isSortPriorityVisible()"
       class="ui-grid-sort-priority-number">
       {{col.sort.priority + 1}}
     </sub>
    </span>
  </div>

  <div
    role="button"
    tabindex="0"
    ui-grid-one-bind-id-grid="col.uid + '-menu-button'"
    class="ui-grid-column-menu-button"
    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"
    ng-click="toggleMenu($event)"
    ng-class="{'ui-grid-column-menu-button-last-col': isLastCol}"
    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"
    aria-haspopup="true">
    <i
      class="ui-grid-icon-angle-down"
      aria-hidden="true">
      &nbsp;
    </i>
  </div>

  <div ui-grid-filter></div>
</div>`;

// `<div ng-class="{ 'sortable': sortable }">
//   <!-- <div class="ui-grid-vertical-bar">&nbsp;</div> -->
//   <div class="ui-grid-cell-contents" col-index="renderIndex" title="TOOLTIP">
//     <span ng-bind-html="col.displayName CUSTOM_FILTERS"></span>
//     <span ui-grid-visible="col.sort.direction" ng-class="{
//       'ui-grid-icon-up-dir': col.sort.direction == asc,
//       'ui-grid-icon-down-dir': col.sort.direction == desc,
//       'ui-grid-icon-blank': !col.sort.direction
//     }">&nbsp;</span>
//   </div>
//   <div class="ui-grid-column-menu-button"
//        ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"
//        ng-click="toggleMenu($event)"
//        ng-class="{'ui-grid-column-menu-button-last-col': isLastCol}">
//     <i class="ui-grid-icon-angle-down">&nbsp;</i>
//   </div>
//   <div ui-grid-filter></div>
// </div>`

// `<div class="ngHeaderSortColumn {{col.headerClass}}" ng-style="{'cursor': col.cursor}" ng-class="{ 'ngSorted': !noSortVisible }">
//     <div ng-click="col.sort($event)" ng-class="'colt' + col.index" class="ngHeaderText">{{col.displayName}}</div>
//     <div class="ngSortButtonDown" ng-show="col.showSortButtonDown()"></div>
//     <div class="ngSortButtonUp" ng-show="col.showSortButtonUp()"></div>
//     <div class="ngSortPriority">{{col.sortPriority}}</div>
//     <div ng-class="{ ngPinnedIcon: col.pinned, ngUnPinnedIcon: !col.pinned }" ng-click="togglePin(col)" ng-show="col.pinnable"></div>
// </div>
// <div ng-show="col.resizable" class="ngHeaderGrip" ng-click="col.gripClick($event)" ng-mousedown="col.gripOnMouseDown($event)"></div>`
